export enum TabTypes {
  FAST = 'fast',
  DELIVERY_ON_TIME = 'deliveryOnTime',
}
